import React from 'react';
import './OutputFormatSelect.css';

// Human-friendly labels for the format keys the backend emits. Unknown keys
// fall back to a title-cased version so a new server-side format still reads
// reasonably without a frontend change.
const FORMAT_LABELS = {
  field_list: 'Field List',
  fhir: 'FHIR',
};

const titleCase = (key) =>
  String(key)
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

export const formatLabel = (key) => FORMAT_LABELS[key] || titleCase(key);

/**
 * Chat output-format picker. "None (plain answer)" is always present and is the
 * default (represented as a null value / empty option). Selecting a format
 * causes it to ride the next message so the backend fills the answer into that
 * format's schema.
 *
 * @param {Object} props
 * @param {string[]} props.formats - Format keys available for the current selection
 * @param {(string|null)} props.value - Current choice (null = None)
 * @param {(next: (string|null)) => void} props.onChange
 * @param {boolean} [props.disabled]
 */
function OutputFormatSelect({ formats = [], value, onChange, disabled = false }) {
  return (
    <div className="output-format-field">
      <span className="output-format-label">Output format:</span>
      <select
        className="chat-mode-select chat-mode-select--toolbar output-format-select"
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        disabled={disabled}
        aria-label="Output format"
        title="Output format"
      >
        {/* "Auto" is the plain-answer default — no output_format sent. */}
        <option value="">Auto</option>
        {formats.map((f) => (
          <option key={f} value={f}>{formatLabel(f)}</option>
        ))}
      </select>
    </div>
  );
}

export default OutputFormatSelect;
